import { useState } from "react";
import { getLocalStorageCustom } from "../../common/utils/StorageUItils";

import bell from "../../common/images/bell.png";
import hamburg from "../../common/images/hamburg.png";
import logo_svg from "../../common/icons/svg/logo.svg";

import "./HeaderMobileView.scss";

const HeaderMobileView = (props) => {



    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

    return (
        <>
            <div className="header-mobile-view">
                <div className='mobile-view-dynamic-island'></div>
                <div className='header-mobile-view-dashboard'>
                    <div className='header-mobile-view-dashboard-hamburg' onClick={() => setIsDrawerOpen(true)}>
                        <img className='hamburg-logo' src={hamburg} alt="logo" />
                    </div>
                    <div className='header-mobile-view-dashboard-title'>
                        Dashboard
                    </div>
                    <div className='header-mobile-view-dashboard-bell'>
                        <img className='bell-logo' src={bell} alt="logo" />
                    </div>

                </div>

                <div className="header-mobile-view-wards">
                    {props?.wardData && Object.values(props.wardData).length > 0 ? (
                        Object.values(props.wardData).map((ward) => {
                            const isSelected = props?.selectedWard?.id === ward.id;

                            return (
                                <div
                                    key={ward.id}
                                    className={`header-mobile-ward-container ${isSelected ? "selected-ward" : ""
                                        }`}
                                    onClick={() => props.handleWardChange(ward)}
                                >
                                    <span className="ward-name">
                                        {ward?.wardName ?? "-"}
                                    </span>

                                    <span className="bed-count">
                                        ({ward?.bedList?.length ?? "-"})
                                    </span>
                                </div>
                            );
                        })
                    ) : (
                        <div className="header-mobile-ward-container">
                            No Wards
                        </div>
                    )}
                </div>
            </div>

            <div
                className={`mobile-overlay ${isDrawerOpen ? "show" : ""}`}
                onClick={() => setIsDrawerOpen(false)}
            />

            <div
                className={`mobile-drawer ${isDrawerOpen ? "open" : ""}`}
            >
                <div className="drawer-header">
                    <div className="drawer-header-user-details">
                        <img className='login-logo' src={logo_svg} alt="logo" />
                        <div className="drawer-header-user-details-email">
                            {getLocalStorageCustom("userEmail") || ""}
                        </div>
                    </div>
                    <div className="drawer-header-cross-icon">
                        <button onClick={() => setIsDrawerOpen(false)}>✕</button>
                    </div>

                </div>

                <div className="drawer-body">
                    <div className="drawer-body-menu">
                    </div>
                    <div className="drawer-body-log-out-button" onClick={() => setIsLogoutModalOpen(true)}
                    >
                        Log Out
                    </div>
                </div>
            </div>

            {/* ===== Logout Confirmation Modal ===== */}
            <div className={`logout-modal-overlay ${isLogoutModalOpen ? "show" : ""}`}>
                <div className="logout-modal">
                    <div className="logout-modal-text">
                        Are you sure you want to logout?
                    </div>

                    <div className="logout-modal-actions">
                        <button
                            className="cancel-btn"
                            onClick={() => setIsLogoutModalOpen(false)}
                        >
                            Cancel
                        </button>

                        <button
                            className="logout-btn"
                            onClick={() => {
                                setIsLogoutModalOpen(false);
                                props.handleSigoutClick();
                            }}
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </div>

        </>


    );
};

export default HeaderMobileView;
